<!-- =========================================================================================
    File Name: ResetPassword.vue
    Description: Reset Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col sm:w-2/4 md:w-1/3 lg:w-2/4 mx-auto self-center">
      <vx-card>
        <div slot="no-body">
          <div class="vx-row">
            <div class="vx-col sm:w-full md:w-full lg:w-full mx-auto self-center d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">Welkom bij Hebtrek.nl</h4>
                  <p>Laten we eerst even een wachtwoord aanmaken, dan kunnen we gelijk aan de slag!</p>
                </div>
                <vs-input
                  type="password"
                  label-placeholder="Wachtwoord"
                  v-model="email"
                  class="w-full mb-6"
                />
                <vs-input
                  type="password"
                  label-placeholder="Wachtwoord herhalen"
                  v-model="email"
                  class="w-full mb-6"
                />

                <div style="float: right; padding-bottom: 25px;">

                  <vs-button class="w-full sm:w-auto" style="text-align: right;" @click="resetPassword">Wachtwoord opslaan</vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: "",
    };
  },

  methods: {
    resetPassword() {
      let data = {
        _method: "POST",
        email: this.email
      };
      let url = "https://companyapi.hebtrek.nl/v1/company-contact/reset-password";
      this.$http
        .post(url, data, {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("companytoken")),
          },
        })
        .then((response) => {
          this.$vs.notify({
            title: "Gelukt!",
            text: "We hebben je een mailtje verstuurd met instructies",
            color: "green",
            position: "top-center",
            fixed: true
          });
        })
        .catch((error) => {
          this.$util.logError(error, this.$vs);
        });
    },
  },
};
</script>
